import React from 'react'

export default function Social() {
  return (
    <div className="home-social">
        <a href="https://github.com/shirleyzero4" className="home-social-icon" target="_blank">
            <i className="uil uil-github-alt"></i>
        </a>

        <a href="https://www.linkedin.com/in/shirley-c-nguyen/" className="home-social-icon" target="_blank">
            <i className="uil uil-linkedin-alt"></i>
        </a>
    </div>    
  )
}
